import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { withRouter } from 'react-router';

import { getLoadingStatus } from './selectors/licenseSelectors';
import { getAllCompanies } from './selectors/companySelectors';
// import { checkForOtherFields } from './CompanyFormContainer';
import { selectCompany } from '../store/actions/companies';
import CompaniesComponent from '../components/profile/Companies/CompaniesComponent';
import { getCurrentUser } from './selectors/userSelectors';

const COMPANY_FORM = 'newCompany';
// const selector = formValueSelector(COMPANY_FORM);

const mapStateToProps = (state, { history, location: { state: locationState = {} }, company }) => ({
    isLoading: getLoadingStatus(state),
    history,
    locationState,
    company,
    companies: getAllCompanies(state),
    user: getCurrentUser(state),
    // ...checkForOtherFields(state, selector, history),
});

const mapDispatchToProps = {
    submitCompanyForm: () => submit(COMPANY_FORM),
    selectCompany,
};

const mergeProps = (
    { history, company, locationState: { activePanel = null }, ...stateProps },
    { submitCompanyForm, selectCompany },
) => {
    return {
        ...stateProps,
        activePanel,
        submitCompanyForm,
        viewLicenses: (companyId) => {
            let promise;

            promise = selectCompany(companyId);
            return promise.then(() => {
                history.push('/profile/licenses');
            });
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withRouter(CompaniesComponent));



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer.js